import React from 'react';

import Badge from '@atlaskit/badge';

const BadgePrimaryExample = (): React.JSX.Element => {
	return <Badge appearance="primary">{5}</Badge>;
};

export default BadgePrimaryExample;
